import { collection, query, where, orderBy, limit, onSnapshot } from 'firebase/firestore';
import { firestore } from '../config/firebase';

/**
 * Live list of pocket campaign aggregates for the broker dashboard (VIP tab).
 * @param {string} brokerUid
 * @param {(rows: Array<{ id: string } & Record<string, unknown>>) => void} onData
 * @param {(err: Error) => void} [onError]
 * @returns {() => void} unsubscribe
 */
export function subscribePocketCampaigns(brokerUid, onData, onError) {
  if (!brokerUid) {
    onData([]);
    return () => {};
  }
  const q = query(
    collection(firestore, 'pocketCampaigns'),
    where('brokerUid', '==', brokerUid),
    orderBy('updatedAt', 'desc'),
    limit(20)
  );
  return onSnapshot(
    q,
    (snap) => {
      onData(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    },
    (err) => {
      console.warn('subscribePocketCampaigns', err);
      onError?.(err);
      onData([]);
    }
  );
}
